import Image from 'app/Components/Shared/Image/image';
import React, { useMemo , useState } from 'react';
import { connect } from 'react-redux';
import { getTransitEffectiveDateText} from '../constant';


/**
 * Parse period key (e.g. "1_2", "3_/") to numeric start for ordering.
 * "A_B" -> A, "A_/" -> A.
 */
function parsePeriodKeyOrder(key) {
  const parts = (key || '').split('_');
  const num = parseInt(parts[0], 10);
  return isNaN(num) ? 0 : num;
}

/**
 * Get period keys sorted by period start (first period first, then next).
 */
function getOrderedPeriodKeys(priceByPeriodByNumOfSub) {
  if (!priceByPeriodByNumOfSub || typeof priceByPeriodByNumOfSub !== 'object') return [];
  return Object.keys(priceByPeriodByNumOfSub).sort(
    (a, b) => parsePeriodKeyOrder(a) - parsePeriodKeyOrder(b)
  );
}

/**
 * Resolve which subscriber-range key applies for a given number of subscribers.
 * Range keys are like "1_2" (1–2 subs) and "3_/" (3+ subs).
 */
function getSubscriberRangeKey(numOfSubs, priceByPeriodByNumOfSub) {
  const ordered = getOrderedPeriodKeys(priceByPeriodByNumOfSub);
  const firstKey = ordered[0];
  const firstPeriodEntries = firstKey
    ? priceByPeriodByNumOfSub[firstKey] || []
    : [];

  const keys = firstPeriodEntries.map((e) => e && e.key).filter(Boolean);
  for (const key of keys) {
    const [fromStr, toStr] = (key || '').split('_');
    const from = parseInt(fromStr, 10);
    const to = toStr === '/' ? Infinity : parseInt(toStr, 10);
    if (!isNaN(from) && numOfSubs >= from && (to === Infinity || numOfSubs <= to)) return key;
  }
  return keys[keys.length - 1] || null;
}


function getPriceForSubRange(periodEntries, subRangeKey , numOfSubs) {
  if (!Array.isArray(periodEntries) || !subRangeKey) return null;
  const item = periodEntries.find((e) => e && e.key === subRangeKey);
  let priceforOneSubscriber = item != null && item.value != null ? Number(item.value) : null;
  return priceforOneSubscriber * numOfSubs;
}



function formatPeriodLabel(periodKey) {
  if (!periodKey) return '';
  const parts = (periodKey || '').split('_');
  const num = parseInt(parts[0], 10);
  if (isNaN(num)) return periodKey;
  return num === 12 ? 'שנה' : `${num} חודשים`;
}

function formatPrice(value) {
 if (value == null || Number.isNaN(value)) return '—';
  return `₪${value > 0 ? Number(value).toFixed(2) : '0'}`;
}

const PriceArea = (props) => {
  const { selectedSubscribers, selectedPackage, subscribersList } = props.personalPricePlan;
  const packageData = selectedPackage.pricePlanMetadata;
  const [isOpen, setIsOpen] = useState(false);

  const isBRB = packageData?.isBRB;
  const priceByPeriodByNumOfSub = packageData?.priceByPeriodByNumOfSub;
  const minimumSubscriberForDiscount = packageData?.minimumSubscriberForDiscount;
  const numOfSubs = selectedSubscribers?.length ;
  const transitPrice = packageData?.transitPrice;
  
  const monthlyCharges = useMemo(() => {
    if (!priceByPeriodByNumOfSub || numOfSubs == 0) return null;
    const periodKeys = getOrderedPeriodKeys(priceByPeriodByNumOfSub);
    if (periodKeys.length === 0) return null;
    const subRangeKey = getSubscriberRangeKey(numOfSubs, priceByPeriodByNumOfSub);
    if (!subRangeKey) return null;

    const firstPeriodKey = periodKeys[0];
    const firstPeriodEntries = priceByPeriodByNumOfSub[firstPeriodKey];
    const firstPrice = getPriceForSubRange(firstPeriodEntries, subRangeKey , numOfSubs);
    const monthlyLabel =
      numOfSubs > 1 ? 'חיוב חודשי ל-' + numOfSubs + ' מנויים' : 'חיוב חודשי';
    let lines = [];

    periodKeys.forEach((periodKey, index) => {
      if (index == 0) {
        lines.push({
          label: ' ' + monthlyLabel,
          price: firstPrice,
        });
      } else {
        const periodEntries = priceByPeriodByNumOfSub[periodKey];
        const periodPrice = getPriceForSubRange(periodEntries, subRangeKey, numOfSubs);
        const periodLabel = formatPeriodLabel(periodKey);
        lines.push({
          label: `חיוב חודשי לאחר ${periodLabel}`,
          price: periodPrice,
        });
      }
    });

    return lines;
  }, [priceByPeriodByNumOfSub, numOfSubs]);


   
  let transitText = numOfSubs > 1 ? `דמי מעבר לכל מנוי` : `דמי מעבר`;
  let singleChargeText = numOfSubs > 1 ? `חיוב חד פעמי ל-${numOfSubs} מנויים` : `חיוב חד פעמי`;
  let transitPriceAmount = transitPrice ? transitPrice * numOfSubs : 0;
  let defaultPrice = monthlyCharges?.length > 0 ? monthlyCharges[0].price : 0;
  let totalText = 'סה"כ '+ formatPrice(defaultPrice) + ' לחודש';
  let disccountText = ' לקבלת ההטבה כדאי לבחור ' + minimumSubscriberForDiscount + ' מנויים ';
  let openOrCloseText = isOpen ? 'סגירה' : 'פרטי הזמנה';
  let showDiscount = numOfSubs < minimumSubscriberForDiscount && isBRB;
  return (

    <div className="price-area-container">
        <div className="totalprice-area">
            <div className="total-text">
                <p>{totalText}</p>
                { showDiscount && (
                    <p>  <Image src={require('../icons/gift.svg')} alt="gift" /> {disccountText}</p>
                )}
               
            </div>
            {defaultPrice > 0 && (
                <div className="openOrCloseBtn" onClick={() => setIsOpen(!isOpen)}>{openOrCloseText}</div>
            )} 
        </div>
        {(defaultPrice >0 && isOpen) && (
            <div className="price-area-calculator">
            <div className="price-area-section">
                <div className="price-area-section-title">חיובים חודשיים</div>
                {monthlyCharges.map((line, index) => (
                <div key={index} className="price-area-row">
                    <span className="price-area-label">{line.label}</span>
                    <span className="price-area-value">{formatPrice(line.price)}</span>
                </div>
                ))}
            </div>
            {transitPrice && (    
                <div className="price-area-section">
                  <div className="price-area-section-title">חיובים חד פעמיים</div>
                    <div className="price-area-row">
                        <span className="price-area-label bright"> {transitText}</span>
                        <span className="price-area-value bright">{formatPrice(transitPrice)}</span>
                    </div>
                    <div className="price-area-row">
                        <span className="price-area-label"> {singleChargeText}</span>
                        <span className="price-area-value ">{formatPrice(transitPriceAmount)}</span>
                    </div>
                </div>
            )}
              <span className="price-area-effective-date"> {getTransitEffectiveDateText(packageData?.isImmediatePlan, packageData?.effectiveDate)}</span>
            </div>
        )}
    </div>
  );
};

const mapStateToProps = (state) => ({
  personalPricePlan: state.personalPricePlan,
});

export default connect(mapStateToProps, null)(PriceArea);
